import { useState } from "react";

import { FilterTag, FilterTagChild } from "features/filters/components";

interface DesktopFilterTagProps {
  icon: JSX.Element;
  label: string;
  selectedFilters: string[];
  onRemove: () => void;
  children?: JSX.Element;
}

export default function DesktopFilterTag({
  icon,
  label,
  selectedFilters,
  onRemove,
  children,
}: DesktopFilterTagProps) {
  const [isDropdownMenuOpen, setIsDropdownMenuOpen] = useState(false);

  const onClick = children ? () => setIsDropdownMenuOpen(true) : undefined;

  return (
    <FilterTag
      onRemove={onRemove}
      dropdownMenuChildren={children}
      isDropdownMenuOpen={isDropdownMenuOpen}
      setIsDropdownMenuOpen={setIsDropdownMenuOpen}
    >
      <FilterTagChild onClick={onClick}>
        {icon}
        {label}
        <span className="text-black-500">
          {selectedFilters.length > 1 ? "is one of" : "is"}
        </span>
        {selectedFilters.length === 1
          ? selectedFilters[0]
          : `${selectedFilters.length} values`}
      </FilterTagChild>
    </FilterTag>
  );
}
